import { RentalConfig } from './types';

export const defaultConfig: RentalConfig = {
  title: 'Nos locations de vacances',
  description: 'Découvrez notre sélection de biens en location de vacances.',
  items: [],
  currency: 'EUR',
  enablePayments: true,
  displayMode: 'grid',
  bookingMode: 'instant',
  depositAmount: 0,
  depositMode: 'none',
  depositRefundDays: 14,
  touristTaxPerPersonPerNight: 0,
  enableReviews: false,
  backgroundColor: '#ffffff',
  primaryColor: '#e63946',
  titleColor: '#212529',
  titleFontSize: '2rem',
  titleBold: true,
  descriptionColor: '#6c757d',
  descriptionFontSize: '1rem',
  itemButtonText: 'Voir & Réserver',
  itemButtonBackgroundColor: '#e63946',
  itemButtonTextColor: '#ffffff',
};
